import React from 'react';

const PdfSideNavigation = ({
  children,
  currentPage,
  pageCount,
  disabled = false,
  onPrevious,
  onNext
}) => (
  <div className="cao-document-viewer__page-navigation-frame">
    {pageCount > 1 && (
      <button
        type="button"
        className="view-button cao-document-viewer__side-navigation cao-document-viewer__side-navigation--previous"
        onClick={onPrevious}
        disabled={disabled || currentPage <= 1}
        aria-label="Previous PDF page"
        title="Previous page"
      >
        <span aria-hidden="true">‹</span>
      </button>
    )}

    {children}

    {pageCount > 1 && (
      <button
        type="button"
        className="view-button cao-document-viewer__side-navigation cao-document-viewer__side-navigation--next"
        onClick={onNext}
        disabled={disabled || currentPage >= pageCount}
        aria-label="Next PDF page"
        title="Next page"
      >
        <span aria-hidden="true">›</span>
      </button>
    )}
  </div>
);

export default PdfSideNavigation;
